var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$globalModel.state.isCouponMall)?_c('CouponHome'):_c('DuoduoHome',{attrs:{"page-hd-height":_vm.pageHeaderHeight}})}
var staticRenderFns = []

export { render, staticRenderFns }